var _g, _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapBozt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_876_89990)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6276 34.3206C34.2079 32.3357 39 26.2275 39 19C39 10.1634 31.8366 3 23 3C14.1634 3 7 10.1634 7 19C7 26.2275 11.7921 32.3357 18.3724 34.3206L22.178 39.8136C22.5757 40.3876 23.4243 40.3876 23.822 39.8136L27.6276 34.3206Z",
    fill: "#FFFEFD"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 19,
    r: 14,
    fill: "#E06749"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8657 23.7319C20.87 23.7319 19.3685 22.2345 19.3685 20.2188C19.3685 18.2223 20.87 16.7058 22.8657 16.7058C24.8614 16.7058 26.3629 18.2223 26.3629 20.2188C26.3629 22.2345 24.8614 23.7319 22.8657 23.7319ZM22.8657 15.3428C20.0908 15.3428 18 17.4353 18 20.2188C18 23.0216 20.0908 25.114 22.8657 25.114C25.6596 25.114 27.7314 23.0216 27.7314 20.2188C27.7314 17.4353 25.6596 15.3428 22.8657 15.3428Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.498 13.6911C18.498 13.3071 18.7832 13 19.1823 13H26.6137C27.0319 13 27.298 13.3071 27.298 13.6911C27.298 14.075 27.0319 14.3822 26.6137 14.3822H19.1823C18.7832 14.3822 18.498 14.075 18.498 13.6911Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_876_89990",
    x: 0,
    y: 0,
    width: 46,
    height: 51.2441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0326543 0 0 0 0 0.0544626 0 0 0 0 0.0544626 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_876_89990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_876_89990",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBozt);
export default __webpack_public_path__ + "static/media/map_bozt.3c36e6c8d2bca2b3963625e83b61ff12.svg";
export { ForwardRef as ReactComponent };